/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuthorizationOAuthAppValidityOperatorSpecVmcfs } from './authorizationOAuthAppValidityOperatorSpecVmcfs';
import { AuthorizationOAuthAppValidityOperatorSpecVcdr } from './authorizationOAuthAppValidityOperatorSpecVcdr';


export interface AuthorizationOAuthAppValidityOperatorSpec { 
    vcdr?: AuthorizationOAuthAppValidityOperatorSpecVcdr;
    vmcfs?: AuthorizationOAuthAppValidityOperatorSpecVmcfs;
}

